<template>
    <div :class="prefixCls">
        <div class="flex items-center gap-75">
            <div class="navigation text-15 font-400 flex justify-between rounded-6">
                <div class="flex-center cursor-pointer pb-5" :class="{ active: active === 'phone' }" @click="handleTabChange('phone')">
                    {{ t('common.phoneLogin') }}
                </div>
                <div class="flex-center cursor-pointer pb-5 mx-76" :class="{ active: active === 'email' }" @click="handleTabChange('email')">
                    {{ t('common.emailLogin') }}
                </div>
            </div>
        </div>
        <el-form class="mt-12px w-335px" ref="ruleFormRef" :rules="rules" @keypress.native.enter.prevent="login" :model="state">
            <template v-if="active === 'phone'">
                <el-form-item prop="mobile">
                    <MobilePhone v-model:mobile="state.mobile" v-model:region="state.region" :disabledCountry="true"></MobilePhone>
                </el-form-item>
                <el-form-item prop="code" class="relative">
                    <el-input
                        v-model="state.code"
                        :placeholder="t('login.input2')"
                        autocomplete="off"
                        size="large"
                        :style="{ '--el-input-text-color': '#000' }"
                    ></el-input>
                    <span @click="getVerfyCode" :disabled="num > 0" class="verfy-word text-[var(--text-color)] absolute right-8px text-16px flex">
                        <span v-if="num" class="flex justify-end">
                            <span class="color-#4B9AFF w-28px">{{ num > 0 ? num + 's' : '' }}</span>
                            <span class="color-#999">{{ t('login.reSend') }}</span>
                        </span>
                        <span v-else class="color-#999 hover-color-#1C80FF">{{ t('login.getCode') }}</span>
                    </span>
                </el-form-item>
            </template>
            <template v-else>
                <el-form-item prop="email">
                    <el-input
                        v-model.trim="state.email"
                        size="large"
                        :style="{ '--el-input-text-color': '#000' }"
                        maxlength="50"
                        :placeholder="t('login.input4')"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="code" class="relative">
                    <el-input
                        v-model="state.code"
                        :placeholder="t('login.input2')"
                        autocomplete="off"
                        size="large"
                        :style="{ '--el-input-text-color': '#000' }"
                    ></el-input>
                    <span @click="getVerfyCode" :disabled="num > 0" class="verfy-word text-[var(--text-color)] absolute right-8px text-16px flex">
                        <span v-if="num" class="flex justify-end">
                            <span class="color-#4B9AFF w-28px">{{ num > 0 ? num + 's' : '' }}</span>
                            <span class="color-#999">{{ t('login.reSend') }}</span>
                        </span>
                        <span v-else class="color-#999 hover-color-#1C80FF">{{ t('login.getCode') }}</span>
                    </span>
                </el-form-item>
            </template>
            <div class="flex">
                <el-button class="w-50% mr-24px" @click="goRegoster">{{ t('login.register') }}</el-button>
                <div class="common-btn-1 w-50% !flex items-center justify-center hover:op-70" @click="login">
                    <span>{{ t('login.login') }}</span>
                </div>
            </div>
        </el-form>
    </div>
    <Dialog v-model:dialogVisible="isShowRegister" width="600px" :title="t('register.title')" class="register-dialog">
        <Register @afterRegister="afterRegister" @cancel="handleCancel" v-if="isShowRegister" />
    </Dialog>
</template>
<script setup lang="ts">
import { mobile, vericode, emailVericode, emailLogin } from '@/apis/login';
import { overseasMobile } from '@/config';
import { useDesign } from '@/hooks/web/useDesign';
import { FormInstance, FormRules } from 'element-plus';
import Dialog from '@/components/Dialog.vue';
import Register from './Register.vue';
import { useI18n } from 'vue-i18n';
import MobilePhone from '@/components/MobileInput.vue';

const { t } = useI18n();

const { getPrefixCls } = useDesign();
const prefixCls = getPrefixCls('login-form');
const emit = defineEmits(['afterLogin']);

const ruleFormRef = ref<FormInstance>();
const state = reactive({
    mobile: '',
    region: '+86',
    code: '',
    email: '',
});
let active = ref('phone');
let timer: any = null;
const rules = computed(() =>
    reactive<FormRules>({
        mobile: [
            { required: true, message: t('login.input1'), trigger: 'change' },
            { pattern: state.region === '+86' ? /^\d{11}$/ : /^\d{1,}$/, message: t('register.errorTip1'), trigger: 'change' },
        ],
        code: [
            { required: true, message: t('login.errorTip1'), trigger: 'change' },
            { pattern: /^\d+$/, message: t('login.errorTip2'), trigger: 'change' },
            { pattern: /^\d{6}$/, message: t('login.errorTip3'), trigger: 'change' },
        ],
        email: [
            { required: true, message: t('login.errorTip4'), trigger: 'change' },
            { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: t('login.errorTip5'), trigger: 'change' },
        ],
    })
);

// 获取验证码
const num = ref(0);
const getVerfyCode = async () => {
    try {
        if (active.value === 'email') {
            await ruleFormRef.value?.validateField('email');
        } else {
            await ruleFormRef.value?.validateField('mobile');
        }
    } catch (e) {
        return;
    }
    if (num.value > 0) return;
    num.value = 60;
    timer = setInterval(() => {
        num.value--;
        if (num.value === 0) {
            clearInterval(timer);
        }
    }, 1000);
    let params: any = {
        mobile: state.mobile,
        region: state.region.slice(1),
    };
    let data = null;
    if (active.value === 'email') {
        params = {
            email: state.email,
        };
        data = await emailVericode(params);
    } else {
        data = await vericode(params);
    }
    if (!data) {
        num.value = 0;
        clearInterval(timer);
    }
};
const isShowRegister = ref(false);
const afterRegister = () => {
    isShowRegister.value = false;
};
const handleCancel = () => {
    isShowRegister.value = false;
};
const goRegoster = () => {
    isShowRegister.value = true;
};

function handleMobileBlur(e: any) {
    state.mobile = e.target.value.replace(/\s/g, '');
}

const login = async () => {
    await ruleFormRef.value?.validate(async (valid, fields) => {
        if (valid) {
            try {
                let params: any = {
                    mobile: state.mobile,
                    region: state.region.slice(1),
                    code: state.code,
                };
                let res = null;
                if (active.value === 'email') {
                    params = {
                        email: state.email,
                        code: state.code,
                    };
                    res = await emailLogin(params);
                } else {
                    res = await mobile(params);
                }
                emit('afterLogin', res);
            } catch (e: any) {
                const code = e.response?.data?.detail?.code;
                if (code === 401) {
                    goRegoster();
                }
            }
        } else {
            console.log('error submit!', fields);
        }
    });
};

function handleTabChange(tab: string) {
    active.value = tab;
    state.code = '';
    state.email = '';
    state.mobile = '';
    // clearInterval(timer);
    // num.value = 0;
}
</script>
<style lang="scss" scoped>
:deep(.el-select__wrapper) {
    padding: 0 8px !important;
}
$prefix-cls: $self-namespace + '-login-form';
.#{$prefix-cls} {
    :deep(.el-input__wrapper) {
        // box-shadow: none !important;
    }
    :deep(.el-form-item) {
        margin-bottom: 24px;
        &.is-error .el-input__wrapper {
            box-shadow: 0 0 0 0.0625rem var(--el-color-danger) inset !important;
        }
        .el-form-item__content {
            background-color: #fff;
            border-radius: 8px;
        }
    }
    :deep(.el-button) {
        height: 40px;
        font-family: AlibabaPuHuiTi-2-65-medium;
    }
}
.verfy-word {
    position: absolute;
    cursor: pointer;

    &[disabled='true'] {
        color: rgb(157, 157, 157);
        cursor: not-allowed;
    }
}
.navigation {
    position: relative;
    div {
        position: relative;
        transition: width 0.5s;
        &::before {
            display: block;
            content: '';
            width: 98%;
            height: 2px;
            position: absolute;
            left: 0;
            bottom: 0;
            border-radius: 3px;
            transition: transform 0.3s ease;
            transform: scaleX(0);
            background: linear-gradient(90deg, #1ba0ff 0%, #0028c6 100%);
        }
        &.active {
            font-weight: 600;
            color: var(--header-active-text-color);
            background: radial-gradient(60% 46% at 50% 100%, rgba(0, 48, 237, 0.3) 0%, rgba(0, 48, 237, 0) 100%);
            &::before {
                transform: scaleX(1);
            }
        }
    }
}
</style>
